import { PolicyDetailInfo } from "kreate-common/modules/business-types";

import { useUser } from "../resources/hooks/useUser";

type Options = {
  returnBanner: boolean;
  canUseTopArtworkAsFallback?: boolean;
};

export default function useFormattedPolicy(
  policyDetailedInfo: PolicyDetailInfo | null | undefined,
  { returnBanner, canUseTopArtworkAsFallback }: Options
) {
  const topArtwork = policyDetailedInfo?.populated.topArtworks?.[0];
  const [user] = useUser(
    policyDetailedInfo?.isUnsortedCollection && returnBanner
      ? policyDetailedInfo?.populated.userProfile?.userId
      : undefined
  );
  return {
    avatar:
      policyDetailedInfo?.avatar ||
      (policyDetailedInfo?.isUnsortedCollection
        ? policyDetailedInfo.populated.userProfile?.avatar
        : undefined) ||
      (canUseTopArtworkAsFallback
        ? topArtwork?.imageFile || topArtwork?.file
        : undefined),
    banner:
      policyDetailedInfo?.banner ||
      (policyDetailedInfo?.isUnsortedCollection ? user?.banner : undefined),
  };
}
